import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed right-0 bottom-0 p-6 slide-in-bottom"
}
const _hoisted_2 = { class: "alert shadow-lg max-w-sm" }
const _hoisted_3 = { class: "flex-col items-start" }
const _hoisted_4 = {
  action: "/set-cookie/",
  method: "post",
  class: "w-full"
}
const _hoisted_5 = ["value"]

import { inject } from "vue";
import { VueCookies } from "vue-cookies";


export default /*@__PURE__*/_defineComponent({
  __name: 'CookiesPopup',
  setup(__props) {

const $cookies = inject<VueCookies>("$cookies") as VueCookies;
const csrfToken = $cookies.get("csrftoken");
const cookiesConsent = $cookies.get("cookies_consent");

// If user has never been to the main website they need to go there first to get the token cookie
if (csrfToken == null) {
  // FIXME: redirect back "/?next=/inscribe"
  window.location.replace("/");
}

return (_ctx: any,_cache: any) => {
  return (!_unref(cookiesConsent))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "font-bold" }, "Cookies", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-sm pb-2" }, [
              _createTextVNode(" We use cookies to ensure you get best experience on our website. "),
              _createElementVNode("a", {
                href: "/cookies/",
                class: "link"
              }, " Learn more ")
            ], -1)),
            _createElementVNode("form", _hoisted_4, [
              _createElementVNode("input", {
                name: "csrfmiddlewaretoken",
                type: "hidden",
                value: _unref(csrfToken)
              }, null, 8, _hoisted_5),
              _cache[0] || (_cache[0] = _createElementVNode("input", {
                type: "hidden",
                name: "key",
                value: "cookies_consent"
              }, null, -1)),
              _cache[1] || (_cache[1] = _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary w-full"
              }, "Got it!", -1))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})